export function preloadItemImages(items) {
  if (!items) return;
  const urls = new Set();
  items.forEach(item => {;
    if (item?.multimedia?.main_image?.thumbnail) urls.add(item?.multimedia?.main_image?.thumbnail);
    if (Array.isArray(item.variants)) {
      item.variants.forEach(variant => {
        if (variant?.multimedia?.main_image?.thumbnail) urls.add(variant?.multimedia?.main_image?.thumbnail);
      });
    }
  });
  urls.forEach(url => {
    const img = new Image();
    if (url.includes('firebasestorage.googleapis.com')) img.crossOrigin = 'anonymous';
    img.src = url;
  });
}

export function preloadCategoryImages(categories) {
  if (!categories) return;
  const urls = new Set();
  categories.forEach(category => {
    if (category?.image) urls.add(category?.image);
  });
  urls.forEach(url => {
    const img = new Image();
    if (url.includes('firebasestorage.googleapis.com')) img.crossOrigin = 'anonymous';
    img.src = url;
  });
};

export function preloadBannerImages(banners) {
  if (!banners) return;
  const urls = new Set();
  banners.forEach(banner => {
    if (banner?.image) urls.add(banner?.image);
  });
  urls.forEach(url => {
    const img = new Image();
    if (url.includes('firebasestorage.googleapis.com')) img.crossOrigin = 'anonymous';
    img.src = url;
  });
};

export function preloadPlaylistVideos(playlist, videos) {
  if (!playlist || !playlist.items || playlist.items.length === 0 || !videos || Object.keys(videos).length === 0) return;
  const urls = new Set();
  playlist.items.forEach(item => {
    if (item.type === 'video') {
      const video = videos[item.id];
      if (video && video.url) urls.add(video.url);
    }
  });
  urls.forEach(url => {
    const video = document.createElement('video');
    if (url.includes('firebasestorage.googleapis.com')) video.crossOrigin = 'anonymous';
    video.src = url;
  });
};